
import moment from 'moment';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import React, { useContext, useEffect, useRef, useState } from 'react';
import ReactToPrint from 'react-to-print';
import { RESORT_NAME_AR, RESORT_NAME_EN } from '../../Helper/user';
import count_days from '../../functions/count_days';
import sum_total_paid from '../../functions/sum_total_paid';
import sum_total_price from '../../functions/sum_total_price';
import view_apartment_type_ar from '../../functions/view_apartment_type';
import view_day_ar from '../../functions/view_day_ar';
import FooterInvoice from './FooterInvoice';
import HeaderInvoice from './HeaderInvoice';
import { InvoiceContext } from './Invoice_Context';
import './invoice.css';
import QRCode from "react-qr-code";
import { view_Apartment } from '../../constants/dataView';

function InvoiceCustomer() {
    const data = useContext(InvoiceContext)
    const toast = useRef(null);
    const componentRef = useRef();
    const buttonRef = useRef();
    // eslint-disable-next-line no-unused-vars
    const [isShown, setIsShown] = useState(false);
    useEffect(() => {
        setTimeout(function () {
            if (data?.success === 1) {
                toast.current.show({
                    style: {
                        fontFamily: "Cairo",
                        fontSize: "1.2rem"
                    },
                    life: 5000,
                    severity: 'success', summary: 'نجــاح', detail: data.msg
                })
            }
        }, 500);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (
        <div className="invoice-print">

            <Toast ref={toast} position="top-center" style={{ margin: "0 1rem 0 0 !important", fontFamily: "Cairo" }} />

            <div id="invoice" className="page page-content fade-in-up" dir="rtl" style={{ margin: "auto", maxWidth: "850PX" }} ref={componentRef}>
                <div className=" ibox ">
                    <div className="invoice-body">

                        <div className="row">
                            <div className="col-12">
                                <HeaderInvoice title={"فاتــورة حجــوزات"}></HeaderInvoice>
                                <div className="col-12">
                                    <div className="row">
                                        <div className="col-6" style={{ borderLeft: "1px solid rgba(0,0,0,.1" }}>
                                            <div className="m-b-5 font-bold">بيانات الزبون</div>
                                            <ul className="list-unstyled m-t-10">
                                                <li className="m-b-5">
                                                    <span className="font-strong"> الأسم  :</span> {data.customer?.visitor_name} </li>
                                                <li className="m-b-5">
                                                    <span className="font-strong"> الهاتف :</span> {data.customer?.phone_number}</li>
                                            </ul>
                                        </div>

                                        <div className="col-6" style={{ borderRight: "1px solid rgba(0,0,0,.1" }}>
                                            <div className="m-b-5 font-bold">بيانات الحجز</div>
                                            <ul className="list-unstyled m-t-10">
                                                <li className="m-b-5">
                                                    <span className="font-strong"> عدد الحجوزات :</span> {data.customer.reservationes.length} </li>
                                                <li className="m-b-5">
                                                    <span className="font-strong"> عدد الأيام :</span> {count_days(data.customer.reservationes)}</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <hr></hr>
                            </div>
                        </div>
                    </div>
                    <div class="table-responsive">
                        <table className="table table-bordered table-striped no-margin table-invoice">
                            <thead className="color-view ">
                                <tr >
                                    <th>الحجز</th>
                                    <th>الإقامة</th>
                                    <th>الأيام</th>
                                    <th colSpan={2} style={{ textAlign: "center" }} >
                                        الدخول - المغادرة
                                    </th>
                                    <th>السعر</th>
                                    <th>الإجمالي</th>
                                    <th>المدفوع</th>
                                    <th>الباقي</th>
                                    <th style={{ textAlign: "center", width: "10%" }}>تاريخ  إلغاء </th>

                                </tr>
                            </thead>
                            <tbody>
                                {
                                    data.customer.reservationes.map((res) => {
                                        return (
                                            <>
                                                <tr>
                                                    <td>{res?.ID_reservation}</td>
                                                    <td>
                                                        {res?.reservation_type === 'service' ? (
                                                            <div>
                                                                <strong>{res?.service_name_ar}</strong>
                                                            </div>
                                                        ) : (
                                                            <div>
                                                                <small>{view_apartment_type_ar(res)}</small><strong>{"-" + res?.number}</strong>
                                                            </div>
                                                        )}

                                                        <small>{res?.number_people} أشخاص </small>
                                                    </td>
                                                    <td>{count_days([res])} أيام</td>
                                                    {
                                                        res.reservation_type === 'service' ? (
                                                            <td colSpan={2}>
                                                                <div>
                                                                    <strong>{res?.date_check_in} </strong>
                                                                </div>
                                                                <small> {view_day_ar(res?.date_check_in)} </small>
                                                            </td>
                                                        ) : (
                                                            <>
                                                                <td>
                                                                    <div>
                                                                        <strong>{res?.date_check_in} </strong>
                                                                    </div>
                                                                    <small> {view_day_ar(res?.date_check_in)} </small>
                                                                </td>
                                                                <td>
                                                                    <div>
                                                                        <strong>{res?.date_check_out}  </strong>
                                                                    </div>
                                                                    <small>  {view_day_ar(res?.date_check_out)} </small>
                                                                </td>
                                                            </>
                                                        )
                                                    }

                                                    <td>{res?.price_day}  د.ل</td>
                                                    <td>{res?.total_price} د.ل</td>
                                                    <td>{res?.total_paid} د.ل</td>
                                                    <td>
                                                        {
                                                            res?.total_price - res?.total_paid === 0 ?
                                                                (
                                                                    <strong style={{ color: "green" }}>
                                                                        خالص
                                                                    </strong>
                                                                )
                                                                :
                                                                (
                                                                    <strong style={{ color: "red" }}>
                                                                        {res?.total_price - res?.total_paid} د.ل
                                                                    </strong>
                                                                )
                                                        }
                                                    </td>

                                                    <td >
                                                        {
                                                            res?.qrcode ?
                                                                <QRCode value={res?.qrcode} size={50} />
                                                                : "-"
                                                        }
                                                    </td>
                                                </tr>

                                            </>
                                        );
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                    <br></br>
                    <div className='col-md-12'>
                        <div className='row'>
                            <div className='col-md-7'>
                                <table className="table table-bordered table-striped no-margin table-invoice">
                                    <thead className="color-view ">
                                        <tr >
                                            <td colSpan={11} style={{ textAlign: "center", fontWeight: "bold", fontSize: "11px" }}>
                                                إجمــالي فــواتير الدفــع
                                            </td>
                                        </tr>
                                        <tr style={{ fontSize: "11px" }} className='p-0 m-0'>
                                            <td colSpan={2} >
                                                رقم الفاتورة
                                            </td>
                                            <td colSpan={3}>
                                                تاريخ الفاتورة
                                            </td>
                                            <td colSpan={2}>
                                                نوع العملية
                                            </td>
                                            <td colSpan={2}>
                                                المبلغ المدفوع
                                            </td>
                                            <td colSpan={3}>
                                                طريقة الدفع
                                            </td>
                                            <td colSpan={3}>
                                                الحجز
                                            </td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            data?.customer?.reservationes?.map(res => {
                                                return <>


                                                    {res?.payments?.map(index => {
                                                        return <tr style={{ fontSize: "12px" }}>
                                                            <td colSpan={2}>
                                                                {index?.ID_payment}
                                                            </td>
                                                            <td colSpan={3}>
                                                                {moment(index?.date_payment).format('yyyy-MM-DD')}
                                                            </td>
                                                            <td colSpan={2}>
                                                                {index?.operation_type}
                                                            </td>
                                                            <td colSpan={2} style={index?.amount < 0 ? { color: "red" } : null} >
                                                                {index?.amount} د،ل
                                                            </td>
                                                            <td colSpan={3}>
                                                                {index?.name_payment_type}
                                                            </td>
                                                            <td colSpan={3}>
                                                                {index?.id_reservation}
                                                            </td>
                                                        </tr>
                                                    })}

                                                </>
                                            })

                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <br></br>
                    <table className="table no-border" width={"50%"}>
                        <thead>
                            {/* <th width="15%"></th> */}
                            {/* {
                            data.total_amount ?
                            (
                                <tr className="text-center" >
                                    <td  className="font-bold font-15 text-left" > القيمة المدفوعة </td>
                                    <td className="font-bold font-15 text-right">{data.total_amount} د.ل</td>
                                </tr>
                            )
                            :
                            (null)
                        }
                        {
                            data.return_amount ?
                            (
                                <tr className="text-center" >
                                    <td  className="font-bold font-15 text-left" > القيمة المسترجعة </td>
                                    <td className="font-bold font-15 text-right" style={{color:"red"}} >
                                        <strong style={{color:"red"}} dir='ltr' >
                                        {data.return_amount}
                                        </strong> د.ل
                                    </td>
                                </tr>
                            )
                            :
                            (null)
                        } */}
                            <tr>
                                <td className="font-bold font-18 text-center">إجمالي المبلغ  </td>
                                <td className="font-bold font-18 text-center">إجمالي المدفوع  </td>
                                <td className="font-bold font-18 text-center">إجمالي المتبقي  </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr >
                                <td className="font-bold font-18 text-center" style={{ padding: "1px" }}>{sum_total_price(data.customer.reservationes)}
                                    د.ل</td>
                                <td className="font-bold font-18 text-center" style={{ padding: "1px" }}>{sum_total_paid(data.customer.reservationes)} د.ل</td>

                                <td className="font-bold font-18 text-center" style={{ padding: "1px" }}>
                                    {
                                        sum_total_price(data.customer.reservationes) - sum_total_paid(data.customer.reservationes) === 0 ?
                                            (
                                                <strong style={{ color: "green" }}>
                                                    خالص
                                                </strong>
                                            )
                                            :
                                            (
                                                <strong style={{ color: "red" }}>
                                                    {sum_total_price(data.customer.reservationes) - sum_total_paid(data.customer.reservationes)} د.ل
                                                </strong>
                                            )
                                    }
                                </td>
                            </tr>
                            <br></br>
                            <tr>
                                <th className="font-bold font-18 text-center" colSpan={10}>
                                    <center>
                                        نتمنى لكم قضاء صيف رائع في {RESORT_NAME_AR} - {RESORT_NAME_EN}
                                    </center>
                                </th>
                            </tr>
                        </tbody>
                    </table>

                </div>
                <div className="print-page-break"></div>

                <div className="invoice-footer">
                    <FooterInvoice></FooterInvoice>
                </div>
            </div>

            <div className="text-center">
                <ReactToPrint
                    trigger={
                        () => <Button dir='ltr' type="button" label=" طبــاعة " icon='fa fa-print' raised
                            ref={buttonRef} onClick={(e) => setIsShown(current => !current)}
                        />
                    }
                    content={() => componentRef.current}
                />
            </div>

        </div>
    );
}
export default InvoiceCustomer;